import styled from "styled-components";

export const LoadingIndicator = styled.div`
	width: 32px;
	height: 32px;
	border: 4px solid #ccc;
	border-radius: 50%;
	border-top-color: #f00; /* Red color for spinning animation */
	animation: spin 1s linear infinite;

	@keyframes spin {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}
`;

export const SuccessMessage = styled.div`
	color: green;
	padding: 8px;
	border: 1px solid green;
	border-radius: 4px;
	margin-top: 8px;
	margin-bottom: 10px;
`;

export const ErrorMessage = styled.div`
	color: red;
	padding: 8px;
	border: 1px solid red;
	border-radius: 4px;
	margin-top: 8px;
	margin-bottom: 10px;
`;

export const ButtonContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	flex-grow: 1; /* Allow this container to grow and take up the remaining space */
	justify-content: center;
	margin: 20px;
`;

export const TextInput = styled.input`
	width: 300px; /* Take up full width of the container */
	height: 40px; /* Adjust height as needed */
	border: 2px solid black; /* Black border */
	border-radius: 5px; /* Rounded corners */
	padding: 8px 12px; /* Padding inside the input field */
	font-size: 1rem; /* Adjust font size as needed */
	box-sizing: border-box; /* Include border and padding in the total width */
	margin-top: 40px; /* Add margin top */
`;

export const HomeContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	min-height: 100vh;
`;

export const HomeText = styled.h1`
	font-size: 48px;
	margin-bottom: 0px;
`;

export const HomeSubText = styled.h1`
	font-size: 48px;
	margin-top: 8px;
	margin-bottom: 20px;
`;
